import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class CommonPopupDemoLimitationComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('account') declare accountService: Service.Account;

	trackingType = 'limitation';

	get isExistingUser() {
		return this.accountService.isExistingUserAccount;
	}

	get isExistingUserEmailSet(): boolean {
		return this.accountService.isExistingUserEmailSet;
	}

	get isExistingUserOrEmailSet(): boolean {
		return this.isExistingUser || this.isExistingUserEmailSet;
	}

	get title() {
		if (this.isExistingUserOrEmailSet) {
			return 'Go back to your account to access this feature';
		} else {
			return 'Create an account';
		}
	}

	get text() {
		if (this.isExistingUserOrEmailSet) {
			return "Switch to your account to use this feature with your company's data.";
		} else {
			return 'Create your own account to customize it with your data.';
		}
	}

	get buttonText() {
		if (this.accountService.isExistingUserEmailSet) {
			return 'Back to my account';
		} else if (this.isExistingUser) {
			return 'Login with your account';
		} else {
			return 'Create an account';
		}
	}

	@action
	redirect() {
		if (this.isExistingUserEmailSet) {
			void this.accountService.redirectToMainAccount(this.trackingType);
		} else if (this.isExistingUser) {
			this.accountService.redirectToLogin(this.trackingType);
		} else {
			this.accountService.redirectToSignup(this.trackingType);
		}
	}
	<template>
		<div class="content">

			<img src="/images/modal/databoard.png" width="352" height="190" alt />
			<h2>{{this.title}}</h2>
			{{#unless this.isExistingUserEmailSet}}
				<div class="under-h2">GET SETUP IN MINUTES, NO CREDIT CARD REQUIRED.</div>
			{{/unless}}
			<p>
				This is a demo account.
				<br />
				{{this.text}}
			</p>

			<div class="controls2 controls2--center">
				<SubmitButtonComponent
					@text={{this.buttonText}}
					@size="big"
					@onTrigger={{this.redirect}}
					@icon={{if this.isExistingUserEmailSet "External"}}
				/>
			</div>

		</div>
	</template>
}
